import { useEffect, useState } from "react";

export const Close = (): JSX.Element => {
	const [opened, setOpened] = useState(false);
	useEffect(() => {
		window.close();
	}, [opened]);
	return <>{window.close()}</>;
};
